import React, { useContext, useEffect, useState } from 'react'

import { convertAmount } from '@/utils/currencyResolver'
import { classNames } from '@/utils/classNames'
import { useFirestore } from 'react-redux-firebase'
import { AuthContext } from '../../../contexts/AuthContext'

export default function AccountBets() {
  const firestore = useFirestore()
  const [duelsData, setDuelsData] = useState([])
  const { auth } = useContext(AuthContext)

  useEffect(() => {
    firestore.collection("duels").where("fightEnd", "!=", null).orderBy("fightEnd", "desc").onSnapshot((snapshot) => {
      let duelsArr = []
      snapshot.docs.forEach(doc => {
        if (doc.data().createdUid == auth?.uid || doc.data().joinedUid == auth?.uid) {
          duelsArr.push({ id: doc.id, ...doc.data(), userWon: doc.data().winner.id == auth?.uid })
        }
      })
      setDuelsData(duelsArr)
    })
  }, [])

  return (
    <div className="grid gap-6">
      {duelsData.length > 0 ? <AccountForm duels={duelsData} /> : (
        <p className="py-16 text-center text-gray-300">You have no bets in your history.</p>
      )}
    </div>
  )
}

const AccountForm = ({ duels }) => {
  return (
    <table className="w-full text-gray-300">
      <thead className="mb-4">
        <tr>
          <th className="w-32 p-4 pt-0 text-sm font-medium text-left">Date</th>
          <th className="w-24 p-4 pt-0 text-sm font-medium text-center">Amount</th>
          <th className="w-24 p-4 pt-0 text-sm font-medium text-right">Payout</th>
        </tr>
      </thead>
      <tbody>
        {duels
          .sort((a, b) => a?.fightEnd > b?.fightEnd ? -1 : 1)
          .map((item, index) => (
            <tr key={index} className="p-4 odd:bg-gray-800">
              <td className="p-4 text-sm rounded-l">{new Date(item.fightEnd.seconds * 1000).toLocaleDateString()} {new Date(item.fightEnd.seconds * 1000).toLocaleTimeString()}</td>
              <td className="p-4 text-sm text-center">{convertAmount(item.wager)}</td>
              <td className="p-4 text-sm rounded-r text-right">
                <span className={classNames('font-medium', item.userWon ? 'text-green-500' : 'opacity-50')}>{item.userWon ? convertAmount(item.payout) : 0}</span>
              </td>
            </tr>
          )
          )}
      </tbody>
    </table>
  )
}